var styles = {
  "Container": "_Container_1op8q_1"
};

export { styles as default };
